import { format } from 'date-fns';
import { emailRegExp, isOver18Years, getDebounce, executeOnce } from 'utils';
import isFuture from 'date-fns/isFuture';
import isDate from 'date-fns/isDate'
import { ErrorMapper, keyMapper } from './constants';
import { SectionLabel, SubSectionLabel } from './common/atoms';
import moment from 'moment';
import { getLanguage } from './utils';
import snackbar from "components/snackbar";
import setLoading from "components/loading";
import { defaultOptionalDocs, defaultDocs } from './types';


const formatPets = (pets, havePets, ErrorMapper) => {
    if (!havePets) return { petsData: [], petsError: { done: true } }

    const dataArray = []
    const errorsArray = []
    pets.forEach((pet) => {

        const errorObj = {}
        const dataObj = {}
        for (let [key, value] of Object.entries(pet)) {
            //From payload, remove id/property whose value is a string otherwise keep it
            if (key == 'id' && typeof value === 'string') {
                continue;
            }

            if (key.includes('Error')) {
                if (key == 'hasError') continue;
                const inputField = key.slice(0, key.length - 5)

                if (!(!!pet[inputField]) || !!value) {
                    errorObj[keyMapper[inputField] || key] = ErrorMapper[inputField]
                }
            }

            if (!key.includes('Error')) {
                dataObj[key] = value;
            }
        }

        errorsArray.push(errorObj)
        dataArray.push(dataObj)
    })

    const haveErrors = errorsArray.some(obj => !!Object.keys(obj).length)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }
    return { petsData: dataArray, petsError: error }
}

const formatVehicles = (vehicles, haveVehicle, keyMapper, ErrorMapper) => {
    if (!haveVehicle) return { vehiclesData: [], vehiclesError: { done: true } }

    const dataArray = []
    const errorsArray = []
    vehicles.forEach((vehicle) => {

        const errorObj = {}
        const dataObj = {}
        for (let [key, value] of Object.entries(vehicle)) {
            //From payload, remove id/property whose value is a string otherwise keep it
            if (key == 'id' && typeof value === 'string') {
                continue;
            }


            if (key.includes('Error')) {
                if (key == 'hasError') continue;
                const inputField = key.slice(0, key.length - 5)

                if (!(!!vehicle[inputField]) || !!value) {
                    errorObj[keyMapper[inputField] || key] = ErrorMapper[inputField]
                }
            }

            if (!key.includes('Error')) {
                dataObj[keyMapper?.[key] || key ] = value;
            }
        }

        errorsArray.push(errorObj)
        dataArray.push(dataObj)
    })

    const haveErrors = errorsArray.some(obj => !!Object.keys(obj).length)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }

    return { vehiclesData: dataArray, vehiclesError: error }
}

const formatEmergencyContacts = (contacts, keyMapper, ErrorMapper) => {
    const dataArray = []
    const errorsArray = []

    contacts.forEach((contact) => {

        const errorObj = {}
        const dataObj = {}
        for (let [key, value] of Object.entries(contact)) {
            if (key == 'hasError') continue;
            if (key.includes('Error')) {
                const inputField = key.slice(0, key.length - 5)

                if (!(!!contact[inputField]) || !!value) {
                    errorObj[keyMapper[inputField] || inputField] = ErrorMapper[inputField]
                }
            } else {
                dataObj[keyMapper[key] || key] = value
            }
        }

        dataArray.push(dataObj)
        errorsArray.push(errorObj)
    })

    const haveErrors = errorsArray.some(obj => !!Object.keys(obj).length)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }

    return { contactsData: dataArray, contactsError: error }
}

const formatMoveIn = (moveInInformation, keyMapper, ErrorMapper) => {
    const { moveInDate, selectedFloorPlan, selectedUnitNumber } = moveInInformation;

    const data = {
        [keyMapper['moveInDate']]: format(moveInDate, 'yyyy-MM-dd'),
        [keyMapper['selectedFloorPlan']]: selectedFloorPlan,
        [keyMapper['selectedUnitNumber']]: selectedUnitNumber
    }

    const error = isFuture(moveInDate) ? { done: true }: { [keyMapper['moveInDate']]: ErrorMapper['moveInDate'] }

    return { moveInData: data, moveInError: error }
}

const formatedOccupants = (occupants, keyMapper, ErrorMapper) => {
    const dataArray = []
    const errorsArray = []
    occupants.forEach((occupant) => {
        // For edit mode, id should not be set by client side
        const isEditMode = window.location.pathname.split("/").reverse()[0];
        isEditMode == 'edit' && typeof occupant.id == 'string' && delete occupant.id;

        const errorObj = {}
        const dataObj = {}
        for (let [key, value] of Object.entries(occupant)) {
            // Set errors
            if (key.includes('Error')) {
                if (key == 'statusError' || key == 'hasError' || key == 'emailError') continue;
                const inputField = key.slice(0, key.length - 5)

                if ((key == 'dobError' && occupant.status == 'leaseholder' && !isOver18Years(occupant[inputField]))) {
                    errorObj[keyMapper[inputField] || key] = ErrorMapper[inputField]
                }
                if (!(!!occupant[inputField]) || !!value) {
                    errorObj[keyMapper[inputField] || key] = ErrorMapper[inputField]
                }
            }

            const mapper = { leaseholder: "Lease Holder", occupant: 'Occupant' }
            if (!key.includes('Error')) {
                dataObj[keyMapper[key] || key] = !isDate(value) ? mapper[value] || value : format(value, 'yyyy-MM-dd')
            }
        }

        errorsArray.push(errorObj)
        dataArray.push(dataObj)
    })

    const haveErrors = errorsArray.some(obj => !!Object.keys(obj).length)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }
    return { occupantsData: dataArray, occupantsError: error }
}
const getOccupantIndex = (occupants, id) => {
    const occupantIndex = occupants.findIndex((person) =>  person.id == id)
    return occupantIndex
}

const formatEmployments = (occupants, employments, keyMapper, ErrorMapper) => {
    const dataArray = []
    const errorsArray = []
      
    employments.forEach((employee) => {

        const errorObj = { address: {} }
        const dataObj = {}

        for (let [key, value] of Object.entries(employee)) {
            if (key == 'hasError') continue;

            if (key.includes('Error')) {
                const inputField = key.slice(0, key.length - 5);
                if(inputField == 'otherIncome') continue;


                if (inputField === 'address') {
                    for (let [key, value] of Object.entries(employee.addressError)) {
                        const subField = key.slice(0, key.length - 5)
                        if (!(!!employee.address[subField]) || !!value) {
                            errorObj.address[keyMapper[subField] || key] = ErrorMapper[subField]
                        }
                    }
                    continue;
                }

                if (!employee[inputField] || !!value) {
                    errorObj[keyMapper[inputField] || inputField] = ErrorMapper[inputField]
                }
            } else {
                if( key == 'otherIncome') {
                   for (let [incomeKey, incomeValue] of Object.entries(value)) dataObj[incomeKey] = incomeValue
                   continue;
                }

                dataObj[keyMapper[key] || key] = value
            }
            const index = getOccupantIndex(occupants, employee.id);
            dataObj.occupant_index = index+1;
        }
        dataArray.push({ ...dataObj, current: true, })
        errorsArray.push(errorObj)
    })

    const haveErrors = errorsArray.some(obj => Object.keys(obj).length > 1)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }
    return { employmentsData: dataArray, employmentsError: error }
}

const formatCurrentResidency = (currentResidency, keyMapper, ErrorMapper) => {

    const dataArray = []
    const errorsArray = []

    currentResidency.current = true;
    const errorObj = { address: {} }
    const dataObj = {}
    for (let [key, value] of Object.entries(currentResidency)) {
        if (key.includes('Error')) {
            if (key == 'hasError') continue;
            const inputField = key.slice(0, key.length - 5)

            if (inputField === 'address') {
                for (let [key, value] of Object.entries(currentResidency.addressError)) {
                    const subField = key.slice(0, key.length - 5)
                    if (!(!!currentResidency.address[subField]) || !!value) {
                        errorObj.address[keyMapper[subField] || key] = ErrorMapper[subField]
                    }
                }
                continue;
            }

            if (!(!!currentResidency[inputField]) || !!value) {
                errorObj[keyMapper[inputField] || key] = ErrorMapper[inputField]
            }


            if (!(!!currentResidency[inputField]) || !!value) {
                errorObj.address[keyMapper[inputField] || key] = ErrorMapper[inputField]
            }
        }

        if (!key.includes('Error')) {
            dataObj[keyMapper[key] || key] = value;
        }
    }

    errorsArray.push(errorObj)
    dataArray.push(dataObj)

    const haveErrors = errorsArray.some(obj => Object.keys(obj).length > 1)
    let error = (haveErrors) ? { collectionErrors: errorsArray } : { done: true }
    return { residencyData: dataArray, residencyError: error }


}


const playloadCreator = (stateManager) => {
    const store = stateManager.store.getState()
    const propertyID = store.property.id

    const { savedFormID, havePets, haveVehicle, occupants, moveInInformation, pets, vehicles,
        currentResidency, employmentInformations, emergencyContacts, selectedLanguage, lastActiveScreen } = store;

    if (!emailRegExp(occupants[0].email)) return

    const { occupantsData, occupantsError } = formatedOccupants(occupants, keyMapper.occupants, ErrorMapper.occupants)
    const { moveInData, moveInError } = formatMoveIn(moveInInformation, keyMapper.moveIn, ErrorMapper.moveIn)
    const { petsData, petsError } = formatPets(pets, havePets, ErrorMapper.pets)
    const { vehiclesData, vehiclesError } = formatVehicles(vehicles, haveVehicle, keyMapper.vehicles, ErrorMapper.vehicles)
    const { contactsData, contactsError } = formatEmergencyContacts(emergencyContacts, keyMapper.emergencyContacts, ErrorMapper.emergencyContacts)
    const { residencyData, residencyError } = formatCurrentResidency(currentResidency, keyMapper.currentResidency, ErrorMapper.currentResidency)
    const { employmentsData, employmentsError } = formatEmployments(occupants, employmentInformations, keyMapper.employments, ErrorMapper.employments)

    const start_time = moment().unix()

    const application = {
        occupants: occupantsData,
        move_in: moveInData,
        pets: petsData,
        vehicles: vehiclesData,
        emergency_contacts: contactsData,
        employments: employmentsData,
        histories: residencyData,
        lang: getLanguage(selectedLanguage),
        start_time,
        saved_form_id: savedFormID || null,
        terms_and_conditions: window.PROPERTY_TERMS,
        last_active_screen: lastActiveScreen || ""

    }

    const formSummary = {
        occupants: occupantsError,
        pets: petsError,
        vehicles: vehiclesError,
        move_in: moveInError,
        emergency_contacts: contactsError,
        histories: residencyError,
        employments: employmentsError,
        income: {
            "done": true
        },
        documents: {
            "collectionErrors": [
                {
                    "file": "document_type_error"
                },
                {
                    "file": "document_type_error"
                },
            ]
        },
        review: {}
    }

    const payload = {
        client_schema: window.CLIENT_SCHEMA,
        saved_form: application,
        property_id: propertyID,
        form_data: {
            form_summary: formSummary,
            start_time: start_time,
            language: getLanguage(selectedLanguage),
            last_active_screen: lastActiveScreen
        }
    }


    return payload
}

const setFormID = executeOnce((r, manager) => {
    manager.setSavedFormID(r.data.id)
})

const saveApplication = (stateManager) => {
    // disable autosave on editing submistted application
    const { isEditMode } = stateManager.store.getState()
    if(isEditMode) return

    const payload = playloadCreator(stateManager)
    stateManager.saveSavedForm(payload)
    .then((r) => setFormID(r, stateManager))
}

const switchLabel = (param) => {
    const id = param?.Id || param
    return id !== 'review' ? SectionLabel : SubSectionLabel
}

const debounce = getDebounce()

const submitApplication = (stateManager, paymentData, property) => {
    const { saved_form, client_schema } = playloadCreator(stateManager)
    // Final payload to submit application
    const payload = {
        client: client_schema,
        payment: paymentData,
        property_id: property.id,
        application_form: saved_form,
    };

    const { uploadedDoc, optionalDocs, photoIDs } = stateManager.store.getState()

    const optionalDocuments = optionalDocs.map((doc) => {
        return {
            type: doc.type,
            url: {
                uuid: doc.docID
            }
        }
    })

    const photoIDDocuments = photoIDs.map((doc) => {
        return {
            type: `photoID-${doc.docID}`,
            url: {
                uuid: doc.docID
            }
        }
    })

    payload.application_form.documents = [
        ...photoIDDocuments,
        ...optionalDocuments,
        {
            "type": "Pay Stub",
            "url": {
                "uuid": uploadedDoc.payStubID
            }
        }
    ]

    return stateManager.saveSubmitApplication(payload)
        .then((res) => {
            stateManager.setPaymentAuthorization(false)
            stateManager.setSelectedTabId('thankyouPage')

            snackbar({
                message: "Application submitted successfully",
                args: { type: 'success' }
            });

            setLoading(false)
        })
        .catch((e) => {
            setLoading(false)
            stateManager.setPaymentAuthorization(false)

            //reset documents states
            stateManager.setOptionalDocs({ ...defaultOptionalDocs });
            stateManager.setUploadedDoc({ ...defaultDocs, payStubIDError: "Please upload paystub", hasError: true });
            const { photoIDs } = stateManager.store.getState()
            const restIDs = photoIDs.map(doc => ({ 
              ...doc, 
              docUrl: '',
              docID: '',
              docIDError: "Please upload photo ID",
              docUrlError: '',
              hasError: true,
            })) 
            stateManager.setPhotoIDs(restIDs);

            snackbar({
                message: e?.response?.data?.error || e.message,
                args: { type: 'error' }
            });
            snackbar({
                message: "Please re-upload the documents.",
                args: {type: 'info'}
            });
        });
}

export {
    submitApplication,
    playloadCreator,
    debounce,
    switchLabel,
    saveApplication,
    getDebounce,
}
